import * as actionTypes from './actionTypes';

export const resetTopologyState = () => {
  return {
    type: actionTypes.RESET_TOPOLOGY_STATE,
    
  };
}

export const initTopologyStart = (days) => {
  return {
    type: actionTypes.INIT_TOPOLOGY_START,
    days: days,
  };
};
export const refreshTopology = () => {
  return window.location.reload();
};
export const setTopology = (realTopology) => {
  return {
    type: actionTypes.SET_TOPOLOGY,
    realTopology: realTopology,
  };
};

export const fetchTopologyFailed = () => {
  return {
    type: actionTypes.FETCH_TOPOLOGY_FAILED,
  };
};

export const initTopology = (days) => {
  return {
    type: actionTypes.INIT_TOPOLOGY,
    days: days || 7,
  };
};
